import { render } from "./StudentList.vue?vue&type=template&id=50349504&scoped=true&ts=true"
import script from "./StudentList.vue?vue&type=script&lang=ts"
export * from "./StudentList.vue?vue&type=script&lang=ts"

import "./StudentList.vue?vue&type=style&index=0&id=50349504&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50349504"]])

export default __exports__